import React, { useMemo } from 'react';
import { Progress, Skeleton } from 'antd';

import { Label } from 'components/Statistic/Label';
import { Widget } from 'components/Statistic/Widget';
import { PlanStats } from 'types';
import cn from './styles.module.scss';

type SurveyUtilizationWidgetProps = {
  planStats?: PlanStats | null,
  loading: boolean,
};

export const SurveyUtilizationWidget = ({ planStats, loading }: SurveyUtilizationWidgetProps) => {
  const items = useMemo(() => {
    const stats = planStats?.stats;

    return stats?.timesSurveyUsed ? stats.timesSurveyUsed.map((item: any) => ({
      title: item.name,
      percent: Math.round((item.mappedCount * 100) / item.total),
      strokeColor: '#55C2EF',
      format: () => `${item.mappedCount} / ${item.total}`,
    })) : [];
  }, [planStats]);

  return (
    <Widget className={cn.progress}>
      <Label>
        Survey Utilization
      </Label>
      <div className={cn.grid}>
        <Skeleton loading={loading} />
        <Skeleton loading={loading} />
        <Skeleton loading={loading} />
        <Skeleton loading={loading} />
        {items.map((item: any, index: number) => (
          <div className={cn.item} key={index}>
            <div className={cn.title}>{item.title}</div>
            <Progress
              strokeWidth={16}
              percent={item.percent}
              strokeColor={item.strokeColor}
              trailColor="#DDF3FC"
              format={item.format}
              type="circle"
            />
          </div>
        ))}
      </div>
    </Widget>
  );
};
